import { HttpErrorResponse } from "@angular/common/http";

export interface LearningTrackingState {
  loading: boolean;
  isEnableLearningTab: boolean | null;
  error: HttpErrorResponse;
}

export const initialLearningTrackingState: LearningTrackingState = {
  loading: false,
  isEnableLearningTab: null,
  error: null
}